import React, { Component } from "react";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container } from "design-react-kit";
import { BoxDanger } from "components/misc";

import { MnemoLoading, ModalHandler } from "components/misc";

import { NavLink, withRouter } from "react-router-dom";
import { RC30_EDITION, ROUTES } from "const";
import { MInput } from "components/forms";
import dayjs from "dayjs";
import ReactHtmlParser from "react-html-parser";

//import "./CourseManager.css";

class LessonLiveSchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      hasSearched: false,
      payload: [],
      payloadToRender: [],
      pagination: {
        currentPage: 1,
        pageSize: 70,
        totalPages: 1,
        totalItems: 0,
      },
      searchFilter: {
        searchCC: "",
        searchFrom: "",
        searchTo: "",
        archivied: this.props.match.params.archivied ? true : false,
      },
      rndKey: 0,
      searchFieldCC: [
        {
          id: "searchCC",
          label: "cerca per classe di concorso",
          type: "text",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchCC", value);
          },
        },
        {
          id: "searchFrom",
          field: "searchFrom",
          label: "dal",
          type: "date",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchFrom", value);
          },
        },
        {
          id: "searchTo",
          field: "searchTo",
          label: "al",
          type: "date",
          className: "form-control",
          value: "",
          onChange: (elm, value) => {
            this.handleSearchFieldChange("searchTo", value);
          },
        },
      ],
    };
  }

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "title",
        Header: "Titolo",
        accessor: (row) => {
          return <span style={{ whiteSpace: "nowrap" }}>{row.title}</span>;
        },
      },
      {
        id: "date",
        Header: "Data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDateFromUtcMidnight(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "Ora inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
      {
        id: "teacher",
        Header: "Docente",
        accessor: (row) => {
          return row.teacher ? <span style={{ whiteSpace: "nowrap" }}>{row.teacher}</span> : "-";
        },
      },
      /*{
        id: "ssd",
        Header: "Materia",
        accessor: "ssd",
      },*/
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: (row) => (
          <>
            <div>
              {row?.competitionClass?.length > 10
                ? row.competitionClass.replaceAll(",", ", ")
                : row.competitionClass}
            </div>
            <div className="small text-muted" style={{ whiteSpace: "nowrap" }}>
              {row.ssd
                ? `SSD: ${row.ssd}`
                : row.sad
                  ? `SAD: ${row.sad}`
                  : "-"}
            </div>
          </>
        ),
      },
      {
        id: "courseCode",
        Header: "Corsi",
        accessor: (row) => {
          const courseCodes = row.courseCode
            ? row.courseCode
                .split(",")
                .map((courseCode) => courseCode.trim())
                .filter(Boolean)
            : [];

          return courseCodes.length ? (
            <div style={{ whiteSpace: "nowrap" }}>
              {courseCodes.map((courseCode, index) => (
                <div key={`${courseCode}-${index}`}>{courseCode}</div>
              ))}
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        id: "classGroup",
        Header: "Aula",
        accessor: (row) => (
          <>
            <div style={{ whiteSpace: "nowrap" }}>{row.classGroup || "-"}</div>
            <div className="small text-muted">
              Edizione: {this.getEdition(row)}
            </div>
          </>
        ),
      },
      /*{
        id: "idExamSession",
        Header: "Edizione",
        accessor: (row) => {
          return this.getEdition(row);
        },
      },*/
      {
        id: "enableAttendance",
        Header: "Attestato",
        accessor: (row) => {
          return row.enableAttendance ? "SI" : "NO";
        },
      },
      {
        id: "accountExt",
        Header: "Account Aula",
        accessor: (row) => {
          // check if item.idMeet value exists
          return row.accountExt && row.idMeet === null
            ? ReactHtmlParser(
                '<b style="color:red;">' + row.accountExt + "</b>",
              )
            : row.accountExt;
        },
      },
    ],

    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(ROUTES.LESSON_LIVE_SCHEDULE_FORM + "/" + value, "_blank");
          //window.location.href = ROUTES.LESSON_LIVE_SCHEDULE_FORM + "/" + value;
        },
      },
      {
        id: "analytics",
        accessor: "id",
        label: "Analytis",
        icon: "it-chart-line",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.open(
            ROUTES.LESSON_LIVE_SCHEDULE_ANALYTICS + "/" + value,
            "_blank",
          );
          //window.location.href = ROUTES.LESSON_LIVE_SCHEDULE_ANALYTICS + "/" + value;
        },
      },
      {
        id: "exportAttendeeswebex",
        accessor: "id",
        label: "Esportazione Partecipanti per WebEx",
        icon: "it-download",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.exportAttendeesWebex(e, value);
        },
      },
      {
        id: "exportAttendeesfull",
        accessor: "id",
        label: "Esportazione Partecipanti Completa",
        icon: "it-download",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.exportAttendeesFull(e, value);
        },
      },
      {
        id: "delete",
        accessor: "id", // field value received in the onclick event
        label: "Elimina",
        icon: "it-delete",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.deleteRecord(e, value);
        },
      },
    ],
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.archivied !== this.props.match.params.archivied
    ) {
      this.setState((prevState) => ({
        loading: false,
        hasSearched: false,
        payload: [],
        payloadToRender: [],
        rndKey: Math.floor(Math.random() * 1000 + 1),
        pagination: {
          ...prevState.pagination,
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
        },
        searchFilter: {
          ...prevState.searchFilter,
          searchCC: "",
          searchFrom: "",
          searchTo: "",
          archivied: this.props.match.params.archivied ? true : false,
        },
        searchFieldCC: prevState.searchFieldCC.map((field) => ({
          ...field,
          value: "",
        })),
      }));
    }
  }

  getEdition(row) {
    let edition = "TUTTI";

    switch (row.idExamSession) {
      case RC30_EDITION.first:
        edition = "PRIMA";
        break;

      case RC30_EDITION.second:
        edition = "SECONDA";
        break;

      case RC30_EDITION.third:
        edition = "TERZA";
        break;

      default:
        edition = "TUTTI";
        break;
    }

    return edition;
  }

  changePage = (newPage) => {
    this.setState(
      (prevState) => {
        if (
          newPage < 1 ||
          newPage > prevState.pagination.totalPages ||
          newPage === prevState.pagination.currentPage
        ) {
          return null;
        }

        return {
          pagination: {
            ...prevState.pagination,
            currentPage: newPage,
          },
        };
      },
      () => {
        this.loadLessonLiveSchedule();
      },
    );
  };

  loadLessonLiveSchedule() {
    this.setState({ loading: true });

    const { currentPage, pageSize } = this.state.pagination;

    const searchFilter = {
      archivied: this.state.searchFilter.archivied,
      searchCC: this.state.searchFilter.searchCC,
      searchFrom: this.state.searchFilter.searchFrom,
      searchTo: this.state.searchFilter.searchTo,
      page: currentPage,
      limit: pageSize,
    };

    adminService
      .loadLessonLiveSchedule({
        searchFilter,
      })
      .then(({ data }) => {
        const lessonLiveSchedule = data?.payload?.lessonLiveSchedule || {};
        const items = Array.isArray(lessonLiveSchedule.items)
          ? lessonLiveSchedule.items
          : [];

        this.setState({
          loading: false,
          hasSearched: true,
          payload: items,
          payloadToRender: items,
          pagination: {
            ...this.state.pagination,
            currentPage,
            totalPages: parseInt(lessonLiveSchedule.totalPages) || 1,
            totalItems: parseInt(lessonLiveSchedule.totalItems) || 0,
          },
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false, hasSearched: true });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            pagination: {
              ...this.state.pagination,
              totalPages: 1,
              totalItems: 0,
            },
            rndKey: Math.floor(Math.random() * 1000 + 1),
            hasSearched: true,
          });
        }
      });
  }

  filterPayload(items, searchFilter) {
    const normalizedCC = searchFilter.searchCC
      ? searchFilter.searchCC.toLowerCase().trim()
      : "";
    const searchFromDate = searchFilter.searchFrom
      ? new Date(searchFilter.searchFrom + "T00:00:00")
      : null;
    const searchToDate = searchFilter.searchTo
      ? new Date(searchFilter.searchTo + "T23:59:59")
      : null;

    return items.filter((item) => {
      let match = true;

      if (normalizedCC) {
        const competition = item.competitionClass
          ? item.competitionClass.toLowerCase()
          : "";
        match = match && competition.includes(normalizedCC);
      }

      const itemDate = item.date ? new Date(item.date) : null;

      if (searchFromDate && !isNaN(searchFromDate.getTime())) {
        match = match && itemDate && itemDate >= searchFromDate;
      }

      if (searchToDate && !isNaN(searchToDate.getTime())) {
        match = match && itemDate && itemDate <= searchToDate;
      }

      return match;
    });
  }

  //--- start functions to delete procedure ---
  deleteRecord(e, value) {
    ModalHandler.show(
      value,
      "Eliminazione definitiva del dato",
      "vuoi davvero eliminare?",
      null,
      this.deletePermanentlyConfirmed,
    );
  }

  deletePermanentlyConfirmed = (value) => {
    adminService
      .deleteLessonLiveSchedule(value)
      .then(({ data }) => {
        this.setState({ loading: true });
        this.loadLessonLiveSchedule();
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };
  //--- end functions to delete procedure ---

  getFieldValueById(id) {
    const field = this.state.searchFieldCC.find((item) => item.id === id);
    return field && field.value ? field.value.trim() : "";
  }

  handleSearchFieldChange = (fieldId, fieldValue) => {
    if (!fieldId) {
      return;
    }

    this.setState((prevState) => ({
      searchFieldCC: prevState.searchFieldCC.map((field) => {
        if (field.id !== fieldId) {
          return field;
        }

        return {
          ...field,
          value: typeof fieldValue === "string" ? fieldValue : "",
        };
      }),
    }));
  };

  handleSearchSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.onSearchForm();
  };

  onSearchForm = () => {
    const searchCC = this.getFieldValueById("searchCC");
    const searchFrom = this.getFieldValueById("searchFrom");
    const searchTo = this.getFieldValueById("searchTo");

    this.setState(
      (prevState) => ({
        pagination: {
          ...prevState.pagination,
          currentPage: 1,
        },
        searchFilter: {
          ...prevState.searchFilter,
          searchCC,
          searchFrom,
          searchTo,
        },
      }),
      () => {
        this.loadLessonLiveSchedule();
      },
    );
  }; //onSearchForm

  onExport = () => {
    //--- prepare header ---
    let str = "";
    str +=
      "Titolo;Data;Ora Inizio;Docente;Materia;Classe di Concorso;Capienza;Aula;Edizione;Attestato;\r\n";

    for (let i = 0; i < this.state.payloadToRender.length; i++) {
      const rows = this.state.payloadToRender[i];
      //--- make rows ---
      const columnOrder = [
        "title",
        "date",
        "hourStart",
        "teacher",
        "ssd",
        "competitionClass",
        "maxMember",
        "classGroup",
        "idExamSession",
        "enableAttendance",
      ];

      let line = "";

      for (const col of columnOrder) {
        if (line !== "") line += ";";
        line += rows[col] !== undefined ? rows[col] : "";
      }
      str += line + "\r\n";
    }

    //--- start download ---
    let downloadLink = document.createElement("a");
    downloadLink.href =
      "data:text/csv;charset=utf-8," + encodeURIComponent(str);
    downloadLink.download =
      "calendarioLezioni_esportato_il_" +
      dayjs().format("DD_MM_YYYY_H_m_s") +
      ".csv";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  exportAttendeesWebex = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    adminService
      .exportAttendees(value)
      .then(({ data }) => {
        //---
        const array = data.payload.lessonLiveSchedule;

        const label = array[0].label.replace(/ /g, "_");

        const headerCSV = { fullname: "Nome", email: "Indirizzo e-mail" };
        array.unshift(headerCSV);

        let str = "";

        for (let i = 0; i < array.length; i++) {
          let line = "";
          for (let index in array[i]) {
            // Prendo solo i primi 2 elementi
            if (
              index !== Object.keys(array[i])[0] &&
              index !== Object.keys(array[i])[1]
            ) {
              continue;
            }

            if (line !== "") line += ";";
            line += array[i][index];
          }

          str += line + "\r\n";
        }

        let downloadLink = document.createElement("a");
        downloadLink.href =
          "data:text/csv;charset=utf-8," + encodeURIComponent(str);
        downloadLink.download = label + "_Webex.csv";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        //---
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };

  exportAttendeesFull = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    adminService
      .exportAttendees(value)
      .then(({ data }) => {
        //---
        const array = data.payload.lessonLiveSchedule;

        const label = array[0].label.replace(/ /g, "_");

        const headerCSV = {
          fullname: "Nome",
          email: "Indirizzo e-mail",
          phone: "Telefono",
        };
        array.unshift(headerCSV);

        let str = "";

        for (let i = 0; i < array.length; i++) {
          let line = "";
          for (let index in array[i]) {
            // Prendo solo i primi 3 elementi
            if (
              index !== Object.keys(array[i])[0] &&
              index !== Object.keys(array[i])[1] &&
              index !== Object.keys(array[i])[2]
            ) {
              continue;
            }

            if (line !== "") line += ";";
            line += array[i][index];
          }

          str += line + "\r\n";
        }

        let downloadLink = document.createElement("a");
        downloadLink.href =
          "data:text/csv;charset=utf-8," + encodeURIComponent(str);

        downloadLink.download = label + "_Full.csv";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        //---
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };

  //--- ---

  render() {
    const { loading } = this.state;
    const { currentPage, totalPages, totalItems } = this.state.pagination;

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="m-0">
            <form onSubmit={this.handleSearchSubmit}>
              <div className="form-row mb-4">
                <div className="col-md-3">
                  <MInput {...this.state.searchFieldCC[0]} className="mb-0" />
                </div>
                <div className="col-md-3">
                  <MInput {...this.state.searchFieldCC[1]} className="mb-0" />
                </div>
                <div className="col-md-3">
                  <MInput {...this.state.searchFieldCC[2]} className="mb-0" />
                </div>
                <div className="col-md-3 text-left">
                  <button type="submit" className="btn btn-primary bg-dark">
                    Cerca
                  </button>
                </div>
              </div>
            </form>

            <div className="form-row mt-3">
              <div className="col-md-12 text-left">
                {this.state.searchFilter.archivied !== true ? (
                  <NavLink
                    to={`${ROUTES.LESSON_LIVE_CALENDAR_WEBEX}`}
                    className="btn btn-primary bg-dark mx-1"
                  >
                    Calendario Aule Webex Correnti
                  </NavLink>
                ) : (
                  <NavLink
                    to={ROUTES.LESSON_LIVE_CALENDAR_WEBEX + "/archiviate"}
                    className="btn btn-primary bg-dark mx-1"
                  >
                    Calendario Aule Webex Archiviate
                  </NavLink>
                )}

                {this.state.searchFilter.archivied !== true && (
                  <NavLink
                    to={ROUTES.LESSON_LIVE_SCHEDULE_FORM}
                    className="btn btn-primary bg-dark mx-1"
                  >
                    Nuova Lezione
                  </NavLink>
                )}

                {this.state.searchFilter.archivied === true ? (
                  <NavLink
                    to={ROUTES.LESSON_LIVE_SCHEDULE}
                    className="btn btn-primary bg-dark mx-1"
                  >
                    Lezioni Correnti
                  </NavLink>
                ) : (
                  <NavLink
                    to={ROUTES.LESSON_LIVE_SCHEDULE + "/archiviate"}
                    className="btn btn-primary bg-dark mx-1"
                  >
                    Lezioni Archiviate
                  </NavLink>
                )}

                <button
                  className="btn btn-primary bg-dark mx-1"
                  onClick={(e) => {
                    this.onExport(e);
                  }}
                >
                  Esporta
                </button>
              </div>
            </div>
          </section>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payloadToRender}
                  tableConfig={this.tableConfig}
                />

                <div className="d-flex justify-content-center align-items-center mt-3 gap-3">
                  <button
                    type="button"
                    className="btn btn-primary bg-dark mr-2"
                    onClick={() => this.changePage(currentPage - 1)}
                    disabled={loading || currentPage <= 1}
                  >
                    Precedente
                  </button>

                  <div className="small text-muted">
                    Pagina {currentPage} di {totalPages} · Totale record:{" "}
                    {totalItems}
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary bg-dark ml-2"
                    onClick={() => this.changePage(currentPage + 1)}
                    disabled={loading || currentPage >= totalPages}
                  >
                    Successiva
                  </button>
                </div>
              </Container>
            )}

            {this.state.hasSearched &&
              this.state.payloadToRender.length === 0 && (
                <BoxDanger key="nrp-1" className="my-3">
                  Ricerca non valida.
                  <div className="small text-info">
                    Nessun dato disponibile.
                  </div>
                </BoxDanger>
              )}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(LessonLiveSchedule);
